/**
 * @Author: hedongyang
 * @Date: 2024-02-04
 * @Description: 菲律宾Tagalog
 */
export default {
  common: {
    submitBtn: 'OK',
    cancelBtn: 'Kanselahin',
    condition: 'kondisyon',
    display: 'display',
    hide: 'Itago'
  },
  tip: {
    select: 'Pakipili',
    input: 'Mangyaring ipasok'
  },
  check: {
    checkAll: 'Piliin lahat'
  },
  upload: {
    upload: 'I-click upang i-upload',
    tip: 'I-drag ang mga file dito, o'
  },
  time: {
    start: 'simula',
    end: 'tapos'
  },
  date: {
    start: 'simula',
    end: 'katapusan',
    t: 'Ngayon',
    y: 'kahapon',
    n: 'Huling 7 araw',
    a: 'lahat'
  },
  form: {
    printBtn: 'I-print',
    mockBtn: 'mock',
    submitBtn: 'isumite',
    emptyBtn: 'malinaw'
  },
  crud: {
    excel: {
      name: 'file name',
      type: 'data',
      typeDic: {
        true: 'Kasalukuyang data (lahat ng data sa kasalukuyang pahina)',
        false: 'Napiling data (napiling data sa kasalukuyang pahina)'
      },
      prop: 'patlang',
      params: 'parameter',
      paramsDic: {
        header: 'header',
        data: 'data source',
        headers: 'Kumplikadong header',
        sum: 'Kabuuang istatistika'
      }
    },
    filter: {
      addBtn: 'Magdagdag ng kundisyon',
      clearBtn: 'I-clear ang data',
      resetBtn: 'I-clear ang mga kundisyon',
      cancelBtn: 'Kanselahin',
      submitBtn: 'OK'
    },
    column: {
      name: 'pangalan ng hanay',
      hide: 'Itago',
      fixed: 'freeze',
      filters: 'filter',
      sortable: 'uriin',
      index: 'order',
      width: 'lapad'
    },
    emptyText: 'Wala pang data',
    tipStartTitle: 'Napili ang kasalukuyang talahanayan',
    tipEndTitle: 'item',
    editTitle: 'I-edit',
    copyTitle: 'Kopyahin',
    addTitle: 'Bago',
    viewTitle: 'View',
    filterTitle: 'Kondisyon ng filter',
    showTitle: 'Ipakita at itago ang hanay',
    menu: 'Operasyon',
    addBtn: 'Bago',
    show: 'ipakita',
    hide: 'Itago',
    open: 'palawakin',
    shrink: 'pag-urong',
    printBtn: 'I-print',
    excelBtn: 'I-export',
    updateBtn: 'Baguhin',
    cancelBtn: 'Kanselahin',
    searchBtn: 'Paghahanap',
    emptyBtn: 'malinaw',
    menuBtn: 'Function',
    saveBtn: 'I-save',
    viewBtn: 'View',
    editBtn: 'edit',
    copyBtn: 'kopya',
    delBtn: 'tanggalin'
  }
};
